import {
  auth,
} from '@/js/firebase/init';

export function firebaseLogout() {
  auth.signOut()
}
